import { KlearDate } from '@klear/date'
import { decodeMoneyWire } from '@klear/money'

export const DATE_FIELDS: readonly string[] = ['effectiveDate', 'endDate']

export function normaliseEditValue(value: string): string | null {
  const trimmed = value.trim()
  return trimmed === '' ? null : trimmed
}

export function normaliseCommittedValue(field: string, value: string | null): string | null {
  if (value === null) return null
  if (field === 'currency') return value.toUpperCase()
  if (field === 'amount') return value.replace(/^([a-z]{3})\s+/i, (_match, code: string) => `${code.toUpperCase()} `)
  return value
}

export function fieldEditIssue(field: string, value: string | null): string | null {
  if (value === null) return null
  if (field === 'currency' && !/^[A-Za-z]{3}$/.test(value)) {
    return 'A currency is a three-letter ISO code, such as USD.'
  }
  if (field === 'amount' && decodeMoneyWire(value) === undefined) {
    return 'Write money as the ISO code, a space, and the figure at that currency’s scale, such as USD 1250.00.'
  }
  if (DATE_FIELDS.includes(field) && KlearDate.parse(value) === undefined) {
    return 'Write the date as YYYY-MM-DD.'
  }
  return null
}
